import { styled } from 'styled-components';

export const DividerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  font: var(--font-body--medium);
  text-transform: uppercase;

  hr {
    border-top: 1px solid var(--color-numa-black--150);
    border-bottom: 1px solid var(--color-numa-black--150);
    flex: 1 0 0;
  }
`;
